<template>
  <div :class="cls">

    <div class="shop-toolbar-changeview">
      <button data-product-view="grid" class="active"><i class="fa fa-th-large"></i></button>
      <button data-product-view="list"><i class="fa fa-th-list"></i></button>
    </div>
    <!--
    <div class="shop-toolbar-items-count">Showing 1–9 of 20 results</div>

    <div class="shop-toolbar-sortby">
      <span>Sort By</span>
      <select name="shop-toolbar-sortby">
        <option value="0">Default Sorting</option>
        <option value="1">Sort By Popularity</option>
        <option value="2">Sort By Price</option>
        <option value="3">Sort By Recent</option>
      </select>
    </div>
-->
    <ul class="shop-toolbar-pagination" v-show="totalPage>1">
      <li v-for="page in totalPage">
        <router-link :to="{ path:$route.path, params: { path: $route.params.path,id:$route.params.id },query:{pageNum:page}}" v-if="$route.query.mainMaterial===''&& $route.query.keyword===''">{{page}}</router-link>
        <router-link :to="{ path:$route.path, params: { path: $route.params.path,id:$route.params.id },
        query:{pageNum:page,keyword:$route.query.keyword}}" v-else-if="($route.query.mainMaterial||'')=='' && $route.query.keyword!='' ">{{page}}</router-link>
        <router-link :to="{ path:$route.path, params: { path: $route.params.path,id:$route.params.id },
        query:{pageNum:page,mainMaterial:$route.query.mainMaterial}}" v-else-if="$route.query.mainMaterial!='' && ($route.query.keyword||'')=='' ">{{page}}</router-link>
        <router-link :to="{ path:$route.path, params: { path: $route.params.path,id:$route.params.id },
        query:{pageNum:page,mainMaterial:$route.query.mainMaterial||'',keyword:$route.query.keyword||''}}" v-else>{{page}}</router-link>
      </li>
    </ul>

  </div>
</template>

<script>
    export default {
      name: "page-toolbars",
      props:{
          cls:"",
          totalPage:{
            type:Number,
            default:1
          },
          pageNum:{
            type:Number,
            default:1
          }
      },
      watch:{
      },
      methods:{
      },
      mounted(){

        $('.shop-toolbar-changeview button').on('click', function(){
          if( $(this).data('product-view') == 'list' ){
            $('.shop-toolbar-changeview button[data-product-view="list"]').addClass('active').siblings().removeClass('active');
            $('.shop-page-products').addClass('active-list-view').removeClass('active-grid-view');
          } else{
            $('.shop-toolbar-changeview button[data-product-view="grid"]').addClass('active').siblings().removeClass('active');
            $('.shop-page-products').addClass('active-grid-view').removeClass('active-list-view');
          }
        });
      }
    }
</script>

<style scoped>

</style>
